export interface PeaConsent {
  optionCode: string;
  optionName: string;
  optionTerm: string;
  termMimeType: string;
}
